module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAAEJQTFRFydP79ff+qLf4hZr2cIn0y9T7ytP7jqL2/v7++Pn+j6P21t782+L8ucb5nK334+j88fP9qrn41Nz7uMX5////T27yt+mm1wAAAQ1JREFUaN7t2OkORDAUBWBjp2gtff9XHa1BbRmJ3iaVc36RK76kugqkgwRAgAABAgQIECBAgHiGDPv0UnbD0EnZH0pAFMLaJcUWKdYKe4i0653YImKttJ4gCR9TniGlqiRWEK6+a3OGNKrCCZC6qmpyZIqfSNmMic+QWFVKgi5sImTjhAIpxJJcI6kQgUbytVJgFtYtv082I9mhZHX5nRDiNd460v1S67tUX3+2SD0/8/jDV/M4mWK+sLLWu0gRJ831nt51azCGUkZPBuOtacXCouUE+T/VM6yMNzcSFpHrLZHfiLlNJUMcHh1Czhn5IWgbL5CLg2nUmmHYQTpD8CsKCBAgQIAAAQIEyIuRL/mBKF+9wNqHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-small.png
// module id = 4HVh
// module chunks = 0